import EgyptResort1 from '../Assets/Images/egypt-resort1.jpg';
import MoroccoResort1 from '../Assets/Images/morocco-resort1.jpg';
import EgyptResort2 from '../Assets/Images/egypt-resort2.jpg';
import EgyptResort3 from '../Assets/Images/egypt-resort3.jpg';
import MoroccoResort2 from '../Assets/Images/morocco-resort2.jpg';
import MoroccoResort3 from '../Assets/Images/morocco-resort3.jpg';

let AfricaDestinationsItems = [
    {
        id: 1,
        itemImage: EgyptResort1,
        itemTitle: 'Red Sea Luxury Escape',
        itemSubTitle: 'Hurghada, Egypt',
        itemNights: '5 nights',
        itemPrice: '£1199'
    },
    {
        id: 2,
        itemImage: MoroccoResort1,
        itemTitle: 'Marrakech Boutique Retreat',
        itemSubTitle: 'Marrakech, Morocco',
        itemNights: '6 nights',
        itemPrice: '£1599'
    },
    {
        id: 3,
        itemImage: EgyptResort2,
        itemTitle: 'Nile View Resort Experience',
        itemSubTitle: 'Luxor, Egypt',
        itemNights: '7 nights',
        itemPrice: '£1299'
    },
    {
        id: 4,
        itemImage: EgyptResort3,
        itemTitle: 'Private Beach Getaway',
        itemSubTitle: 'Sharm El Sheikh, Egypt',
        itemNights: '5 nights',
        itemPrice: '£999'
    },
    {
        id: 5,
        itemImage: MoroccoResort2,
        itemTitle: 'Atlas Mountains Escape',
        itemSubTitle: 'Imlil, Morocco',
        itemNights: '6 nights',
        itemPrice: '£1299'
    },
    {
        id: 6,
        itemImage: MoroccoResort3,
        itemTitle: 'Coastal Surf & Chill Stay',
        itemSubTitle: 'Essaouira, Morocco',
        itemNights: '5 nights',
        itemPrice: '£999'
    }
];

export default AfricaDestinationsItems;
